
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { TenantResource } from "@/api/requests/tenant/types";
import { State } from "vuex-class";
import AccountMultipleOutlineIcon from "vue-material-design-icons/AccountMultipleOutline.vue";
import CalendarOutlineIcon from "vue-material-design-icons/CalendarOutline.vue";
import CheckboxMarkedCircleOutlineIcon from "vue-material-design-icons/CheckboxMarkedCircleOutline.vue";
import EmailMultipleOutlineIcon from "vue-material-design-icons/EmailMultipleOutline.vue";
import ClipboardOutlineIcon from "vue-material-design-icons/ClipboardOutline.vue";
import ViewDashboardOutlineIcon from "vue-material-design-icons/ViewDashboardOutline.vue";
import PackageVariantIcon from "vue-material-design-icons/PackageVariant.vue";
import FileDocumentOutlineIcon from "vue-material-design-icons/FileDocumentOutline.vue";
import FormSelectIcon from "vue-material-design-icons/FormSelect.vue";
import ChartPieIcon from "vue-material-design-icons/ChartPie.vue";
import BullseyeArrow from "vue-material-design-icons/BullseyeArrow.vue"
import HailIcon from "vue-material-design-icons/Hail.vue";
import AppMenuNavItem from "@/components/AppMenuNavItem.vue";

const articleModule = namespace("article");
const calendarModule = namespace("calendar");
const evaluatorModule = namespace("evaluator");
const newsletterModule = namespace("newsletter");
const vacationModule = namespace("vacation");
const profileModule = namespace("profile");
const taskModule = namespace("task");
const workModule = namespace("work");
const quoteModule = namespace("quote");
const proposalModule = namespace("proposal");
const statisticModule = namespace("statistic");

@Component({
  components: {
    AppMenuNavItem,
    AccountMultipleOutlineIcon,
    CalendarOutlineIcon,
    CheckboxMarkedCircleOutlineIcon,
    EmailMultipleOutlineIcon,
    ClipboardOutlineIcon,
    ViewDashboardOutlineIcon,
    PackageVariantIcon,
    FileDocumentOutlineIcon,
    FormSelectIcon,
    ChartPieIcon,
    HailIcon,
    BullseyeArrow
  },
})
export default class AppMenuNav extends Vue {

  @State tenant!: TenantResource;

  @Prop(Boolean) readonly collapsed: boolean | undefined;

  get evaluatorSectionName(){
    return this.tenant.slug === 'tenderpeople' ? "TPM" : "Valutazioni";
  }

  @articleModule.Getter articleModuleEnabled: any;
  @calendarModule.Getter calendarModuleEnabled: any;
  @evaluatorModule.Getter packageModuleEnabled: any;
  @newsletterModule.Getter newsletterModuleEnabled: any;
  @taskModule.Getter taskModuleEnabled: any;
  @vacationModule.Getter vacationModuleEnabled: any;
  @workModule.Getter workModuleEnabled: any;
  @profileModule.Getter anagraficaModuleEnabled: any;
  @quoteModule.Getter quoteModuleEnabled: any;
  @proposalModule.Getter proposalModuleEnabled: any;
  @proposalModule.Getter sampleModuleEnabled: any;
  @statisticModule.Getter statisticModuleEnabled: any;

  closeMenuNav() {
    this.$root.$emit('toggleHamburgerMenu');
  }

}
